import { render, staticRenderFns } from "./ExpandedExtraFieldsComponent.vue?vue&type=template&id=ee5f8fa0&scoped=true&"
import script from "./ExpandedExtraFieldsComponent.vue?vue&type=script&lang=js&"
export * from "./ExpandedExtraFieldsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ExpandedExtraFieldsComponent.vue?vue&type=style&index=0&id=ee5f8fa0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5f8fa0",
  null
  
)

export default component.exports